module.exports = "https://redage.akamaized.net/src/views/player/documets/fibbadge/images/fib_logo.png";